<template>
  <q-card
    style="width: 98vw; min-width: 500px; max-width: 1500px; height: 98vh"
  >
    <q-table
      style="max-height: calc(100%); height: calc(100%)"
      class="rounded-borders sticky-header-table"
      :data="answer"
      :columns="columnDef"
      :loading="loadingAnswer"
      row-key="index"
      virtual-scroll
      :pagination.sync="pagination"
      :rows-per-page-options="[0]"
      separator="cell"
      hide-bottom
    >
      <template v-slot:top>
        <div class="full-width row justify-between">
          <div style="font-size: 1.2rem; font-weight: bold">
            问卷质量控制 <span class="text-subtitle1">查看答案</span>
          </div>

          <div>
            <!-- <q-radio
              v-model="shape"
              val="进行中"
              label="进行中"
              v-if="startQualityChecking"
            />
            <q-radio
              v-model="shape"
              val="无需处理"
              label="无需处理"
              v-if="startQualityChecking"
              class="q-mr-md"
            /> -->

            <q-btn
              color="primary"
              outline
              v-if="startQualityChecking"
              class="q-mr-md"
              @click="markNotNeeded()"
            >
              标记为「无需处理」
            </q-btn>
            <q-btn
              color="primary"
              outline
              v-if="startQualityChecking"
              class="q-mr-md"
              @click="saveQuality()"
            >
              暂存
              <q-tooltip> 暂存将会更新修改内容，并标记状态为进行中 </q-tooltip>
            </q-btn>
            <q-btn
              v-if="!startQualityChecking"
              color="primary"
              @click="qualityCheck()"
            >
              开始处理
              <q-tooltip>
                开始处理将会将当前用户设置为样本负责人，并标记状态为进行中
              </q-tooltip>
            </q-btn>
            <q-btn v-else color="primary" @click="qualityCheck()">
              保存并提交
            </q-btn>
            <q-btn dense flat v-close-popup class="q-ml-md">
              <q-icon name="fas fa-times" size="1rem" />
              <q-tooltip content-class="bg-white text-primary"
                >关闭窗口</q-tooltip
              >
            </q-btn>
          </div>
        </div>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="code" :props="props">
            {{ props.row.code }}
          </q-td>

          <q-td
            key="desc"
            :props="props"
            style="max-width: 300px; white-space: pre-wrap"
          >
            {{ props.row._q }}
          </q-td>

          <q-td key="answer" :props="props" style="min-width: 250px">
            <span v-if="props.row.answer.length === 0"> 未作答 </span>

            <q-list>
              <q-item v-for="answer in props.row.answer" :key="answer.code">
                <span>{{ answer.code }}</span>
                、
                <span style="white-space: pre-wrap; text-align: start">{{
                  answer.value
                }}</span>
              </q-item>
            </q-list>
          </q-td>

          <q-td key="remark" :props="props">
            {{ props.row.remark }}
          </q-td>

          <q-td v-if="startQualityChecking" key="edit">
            <q-btn
              v-if="
                currentUpdateAnswer(props.row.code) ||
                currentAnswerNotes(props.row.code)
              "
              color="primary"
              flat
              @click="showViewNotes(props)"
            >
              <q-icon name="fas fa-eye" size="0.8rem" />
              <q-tooltip> 查看信息 </q-tooltip>
            </q-btn>

            <q-btn color="primary" flat @click="showEditNotes(props)">
              <q-icon name="fas fa-pen" size="0.8rem" />
              <q-tooltip> 修改答案信息 </q-tooltip>
            </q-btn>
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <q-dialog v-model="editNotes" persistent>
      <QualityAnswerNotesEdit
        v-on:pushUpdateAnswerArrary="pushUpdateAnswerArrary"
        :question="question"
      />
    </q-dialog>

    <q-dialog v-model="viewNotes" v-if="currentProps">
      <q-card style="min-width: 40vw">
        <q-card-section class="row bg-grey-3 items-center">
          信息如下：
        </q-card-section>
        <q-card-section v-if="currentUpdateAnswer(currentProps.row.code)">
          当前修改内容 <br />
          {{ currentUpdateAnswer(currentProps.row.code) }}
        </q-card-section>
        <q-card-section
          v-if="currentAnswerNotes(currentProps.row.code)"
          class="bg-yellow-3 q-ma-md"
        >
          已记录内容 <br />
          {{ currentAnswerNotes(currentProps.row.code) }}
        </q-card-section>
        <q-card-section class="bg-yellow-2 q-ma-md">
          原始信息 <br />
          {{ currentProps.row.answer }}
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-card>
</template>

<script>
import { getSubmitedAnswer } from "@/api/endpoints/answer/getSubmitedAnswer";
import { updateAdminQualityNotes } from "@/api/endpoints/admin-quality/updateAdminQualityNotes";
import { updateAdminQualityStatus } from "@/api/endpoints/admin-quality/updateAdminQualityStatus";
import { EventBus } from "@/bus/index";
import { SAMPLE_RESET_LIST_CHANGED } from "@/bus/admin.events";

export default {
  components: {
    QualityAnswerNotesEdit: () => import("./QualityAnswerNotesEdit"),
  },
  props: {
    sampleId: {
      type: String,
      default: "",
    },
    oldNotes: {
      type: Array,
      default: "",
    },
  },

  data() {
    return {
      answer: [],
      loadingAnswer: false,
      columnDef: [
        {
          name: "code",
          label: "问题代号",
          align: "center",
          sortable: true,
        },
        {
          name: "desc",
          label: "问题描述",
          align: "center",
        },
        {
          name: "answer",
          label: "答案",
          align: "center",
        },
        {
          name: "remark",
          label: "访员备注",
          align: "center",
        },
      ],
      startQualityChecking: false,
      pagination: {
        rowsPerPage: 0,
      },
      maximizedToggle: true,
      shape: "进行中",
      editNotes: false,
      viewNotes: false,
      updateAnswerNotes: [],
      question: "",
      currentProps: null,
    };
  },

  // computed: {

  // },

  watch: {
    sampleId: {
      immediate: true,
      handler(id) {
        if (id) this.fetchAnswer(id);
      },
    },
    startQualityChecking: {
      immediate: true,
      handler() {
        if (this.startQualityChecking) {
          this.columnDef = [
            {
              name: "code",
              label: "问题代号",
              align: "center",
              sortable: true,
            },
            {
              name: "desc",
              label: "问题描述",
              align: "center",
            },
            {
              name: "answer",
              label: "答案",
              align: "center",
            },
            {
              name: "remark",
              label: "访员备注",
              align: "center",
            },
            {
              name: "edit",
              label: "操作",
              align: "center",
            },
          ];
        }
        if (!this.startQualityChecking) {
          this.columnDef = [
            {
              name: "code",
              label: "问题代号",
              align: "center",
              sortable: true,
            },
            {
              name: "desc",
              label: "问题描述",
              align: "center",
            },
            {
              name: "answer",
              label: "答案",
              align: "center",
            },
            {
              name: "remark",
              label: "访员备注",
              align: "center",
            },
          ];
        }
      },
    },

    shape: {
      immediate: false,
      handler() {
        //
        // console.log(this.shape);
        this._updateStatus(this.shape);
      },
    },
  },

  methods: {
    async fetchAnswer(sampleId) {
      try {
        this.loadingAnswer = true;
        const response = await getSubmitedAnswer(sampleId);
        const answerObj = Object.keys(response.value).reduce(
          (res, groupId) => ({ ...res, ...(response.value[groupId] || {}) }),
          {}
        );
        this.answer = Object.keys(answerObj).map((code) => ({
          code,
          ...answerObj[code],
        }));
        this.answer.sort((a1, a2) => {
          if (a1.code > a2.code) return 1;
          else return -1;
        });
        // console.log("answer", this.answer);
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "加载失败，" + err,
        });
      } finally {
        this.loadingAnswer = false;
      }
    },

    async qualityCheck() {
      try {
        this.startQualityChecking = !this.startQualityChecking;
        // 进入到进行中
        if (this.startQualityChecking) {
          this._updateStatus("进行中");
          this.$q.notify({
            type: "success",
            message: "质控状态更新为「进行中」",
          });
        }

        // 标记为完成
        if (!this.startQualityChecking) {
          // console.log('有历史的完成记录')

          await this._updateAnswerNotesSafe();
          await this._updateStatus("完成");

          this.$q.notify({
            type: "success",
            message: "质控状态更新为「完成」",
          });
          await this.$emit("closeQualityEditor", true);
          EventBus.$emit(SAMPLE_RESET_LIST_CHANGED);
        }
      } catch (error) {
        this.$q.notify({
          type: "danger",
          message: "加载失败，" + err,
        });
      }
    },

    async markNotNeeded() {
      await this._updateStatus("无需处理");

      await this.$emit("closeQualityEditor", true);
      await this._updateAnswerNotesSafe();
      this.$q.notify({
        type: "success",
        message: "修改已经保存，质控状态更新为「无需处理」",
      });
      EventBus.$emit(SAMPLE_RESET_LIST_CHANGED);
    },

    async saveQuality() {
      await this._updateStatus("进行中");
      await this.$emit("closeQualityEditor", true);
      await this._updateAnswerNotesSafe();
      this.$q.notify({
        type: "success",
        message: "质控状态更新为「进行中」",
      });

      EventBus.$emit(SAMPLE_RESET_LIST_CHANGED);
    },

    pushUpdateAnswerArrary(newAnswer) {
      // console.log("newAnswer", newAnswer);
      this.updateAnswerNotes.push(newAnswer);
      this.editNotes = false;
    },

    async _updateStatus(status) {
      try {
        await updateAdminQualityStatus(this.sampleId, status);
      } catch (error) {
        console.log(eeror);
        this.$q.notify({
          type: "danger",
          message: "加载失败，" + err,
        });
      }
    },

    async _updateAnswerNotesSafe() {
      //已有历史记录
      if (this.oldNotes.length !== 0) {
        const concatList = this.oldNotes.concat(this.updateAnswerNotes);
        if (this.updateAnswerNotes.length !== 0) {
          await updateAdminQualityNotes(this.sampleId, concatList);
        }
      } else {
        // console.log('全新完成记录')
        if (this.updateAnswerNotes.length !== 0) {
          await updateAdminQualityNotes(this.sampleId, this.updateAnswerNotes);
        }
      }
    },

    /**
     * code: 问题的code
     */
    currentUpdateAnswer(code) {
      const newUpdateAnswer = this.updateAnswerNotes.filter((item) => {
        return Object.keys(item)[0] === code;
      });
      if (newUpdateAnswer.length === 0) return;
      return newUpdateAnswer;
    },

    currentAnswerNotes(code) {
      // console.log("coooodddeeee", this.oldNotes);
      if (!this.oldNotes) return;
      const foundOldNotes = this.oldNotes.filter((item) => {
        return Object.keys(item)[0] === code;
      });
      if (foundOldNotes.length === 0) return;
      return foundOldNotes;
    },

    showEditNotes(question) {
      this.editNotes = true;
      this.question = question;
    },
    showViewNotes(props) {
      this.currentProps = props;
      this.viewNotes = true;
    },
  },
};
</script>

<style></style>
